import React, { useState } from "react";
import { Button, Drawer, notification, Input } from "antd";
import { SendShortlistDrawerWrapper, SendShortlistLoadingWrapper } from "./ShortlistUI";
import PackageIndexItem from "components/PackageIndex/PackageIndexItem";
import Axios from "axios";
import { PACKAGE_ACTIONS, usePackage, usePackageDispatch } from "contexts/PackageContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { light } from "@fortawesome/fontawesome-svg-core/import.macro";

const TextArea = Input.TextArea;

const ShortlistSendDrawer = ({ shortlistModels }) => {
    const { packageCode } = usePackage();
    const dispatch = usePackageDispatch();
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);

    const sendShortlist = async () => {
        setLoading(true);
        try {
            await Axios.post(`/favourites/sendtobooker`, {
                PackageCode: packageCode,
                Message: message,
                BookerTemplate: "shortlist-booker.cshtml",
                BookerTemplateIsCustom: false,
                RecipientTemplate: "shortlist-recipient.cshtml",
                RecipientTemplateIsCustom: false,
            });
            setMessage("");
            setTimeout(() => {
                setLoading(false);
                dispatch({ type: PACKAGE_ACTIONS.SET_MESSAGE_DRAWER_OPEN, payload: false });
                notification.open({
                    message: "Shortlist Sent",
                    description:
                        <p>Your shortlist has been sent to this booker.<br/>You will get a summary by e-mail</p>,
                    duration: 5,
                });
            }, 2000);
        } catch (error) {
            setLoading(false);
        }
    };

    const handleCloseMessageDrawer = () => {
        dispatch({ type: PACKAGE_ACTIONS.SET_MESSAGE_DRAWER_OPEN, payload: false });
    };

    return (
        <Drawer title="Send Shortlist" placement="right" closable={true} onClose={handleCloseMessageDrawer} open>
            {loading ? (
                <SendShortlistLoadingWrapper>
                    <FontAwesomeIcon
                        className="sending-icon"
                        icon={light("paper-plane")}
                        size="4x"
                        bounce
                    />
                    <div className="sending-text">sending shortlist</div>
                </SendShortlistLoadingWrapper>
            ) : (
                <SendShortlistDrawerWrapper>
                    <TextArea
                        rows={8}
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        placeholder="Add a message to the booker..."
                    />
                    <div className="button-wrapper">
                        <Button type="primary" size="large" onClick={sendShortlist}>
                            Send
                        </Button>
                    </div>
                    <div className="models-group-container">
                        <h2 className="models-group-name">Models in Shortlist</h2>
                        <div className="models-container">
                            {shortlistModels.map((model) => {
                                return <PackageIndexItem inShortlist key={`${model.ID}`} model={model} readOnly />;
                            })}
                        </div>
                    </div>
                </SendShortlistDrawerWrapper>
            )}
        </Drawer>
    );
};

export default ShortlistSendDrawer;
